import { apiService } from './apiService';

/* ───────────── generic list ───────────── */
export const getItemCategoryService = (data) =>
  apiService({
    method: 'POST',
    url: '/item-category/data',
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });

/* ───────────── single CRUD ───────────── */
export const getByIdItemCategoryService = (id) =>
  apiService({ method: 'GET', url: `/item-category/${id}` });

export const addItemCategoryService = (data) =>
  apiService({ method: 'POST', url: '/item-category', data });

export const updateItemCategoryService = (id, data) =>
  apiService({ method: 'PUT', url: `/item-category/${id}`, data });

export const deleteItemCategoryService = (id) =>
  apiService({ method: 'DELETE', url: `/item-category/${id}` });

/* ───────────── table helper (if used elsewhere) ───────────── */
export const getTableCategoryService = () =>
  apiService({ method: 'GET', url: '/front/category/data' });
